module.exports = __webpack_public_path__ + "static/media/AB_K2_6.ce566a97.jpg";